import { Component, Input } from '@angular/core';

@Component({
  selector: 'user-collapsible-header',
  templateUrl: './collapsible-header.component.html',
  styleUrls: ['./collapsible-header.component.css']
})
export class CollapsibleHeaderComponent {
  @Input() header: string;
}
